module.exports = __webpack_public_path__ + "img/coupon-bubble.7ed21dd9.png";